import { IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common";
import { ICreateRuleDTO } from "../../../../../libs/coreapi-dto/dirs/constructorSchemes";
import { IChangeKizConstructorDocument, IChangeScheme, IChangeStore, IOnInit, ISetContractors, ISetStores } from "./actionType";


export interface IInitialState {
    createRule: ICreateRuleDTO
    kizConstructorDoc: IEntitySimpleDTO | null
    store: IEntitySimpleDTO | null
    stores: IEntitySimpleDTO[]
    scheme: IEntitySimpleDTO | null
    contractors: IEntitySimpleDTO[]
    idTable: number | null
}

type Action = IChangeKizConstructorDocument | IChangeStore | ISetStores | IChangeScheme | ISetContractors | IOnInit


export const initialState: IInitialState = {
    createRule: {} as ICreateRuleDTO,
    kizConstructorDoc: null,
    store: null,
    stores: [],
    scheme: null,
    contractors: [],
    idTable: null
};

export function reducer(state: IInitialState = initialState, action: Action): IInitialState {
    switch (action.type) {

        case 'changeKizConstructorDocument':
            return { ...state, createRule: { ...state.createRule, idKizConstructorDocument: action.payload.id }, kizConstructorDoc: action.payload.entity, idTable: action.payload.idTable }

        case 'changeStore':
            return { ...state, createRule: { ...state.createRule, idStoresGlobal: action.payload.ids }, store: action.payload.entity, stores: action.payload.entity ? [action.payload.entity] : [] }

        case 'setStores':
            return { ...state, createRule: { ...state.createRule, idStoresGlobal: action.payload.ids }, store: action.payload.entities[0] ?? null, stores: action.payload.entities }

        case 'changeScheme':
            return { ...state, createRule: { ...state.createRule, idSchemeGlobal: action.payload.id }, scheme: action.payload.entity }

        case 'setContractors':
            return { ...state, createRule: { ...state.createRule, contractors: action.payload.id.map((x) => ({ idContractorGlobal: x })) }, contractors: action.payload.entities }
        case 'onInit':
            return { ...state, createRule: { ...state.createRule, idKizConstructorDocument: action.payload.idDoc, idStoresGlobal: action.payload.stores!.map(store => store.idGlobal), idSchemeGlobal: action.payload.idScheme, contractors: action.payload.contractors.map((x)=>({idContractorGlobal: x.idGlobal})) }, kizConstructorDoc: action.payload.docEntity, idTable: action.payload.idTable, store: action.payload.storeEntity, stores: action.payload.stores ?? (action.payload.storeEntity ? [action.payload.storeEntity] : []), scheme: action.payload.schemeEntity, contractors: action.payload.contractors }
        default:
            throw new Error();
    }
}
